import React, { useState, useEffect } from "react";
import GUIset_nButton from "./gui/GUIset_nButton";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";

const BooleanParenthesization = () => {
	useEffect(() => {
		document.title =
			"Boolean Parenthesization: parenthesize the expression so the value is TRUE";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState("T ^ F & T");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonList = [
		{ label: "Random Input", color: "#888888" },
		{ label: "Calculate", color: "#000000" },
	];
	const buttonClick1 = (i) => {
		if(i == 0) buttonRandomInput();
		else process();
	};

	// var arr = [];
	// var result_list = {};
	var txt_time = "";
	var txt_result = "";
	var list_operator = ["&","|","^"];
	var symb = [];
	var oper = [];

	function buttonRandomInput() {
		var txt = "";
		var l = T.rand(5);
		if (l % 2 == 0) l++;
		for (var i = 0; i < 4 + l; i++) {
			if(txt != "") txt += " ";
			if (i % 2 == 0) T.rand(2) ? (txt += "F") : (txt += "T");
			else txt += list_operator[T.rand(3)];
		}
		guiTxtChange1(txt);
	}

	function process() {
		if (guiTxt1 != "") {
			loadInput(guiTxt1);
			Timer.start();
			txt_result = countParenth();
			txt_time = Timer.stop_print();
			BuildResult();
		}
	}
	
	function loadInput(str)
	{
		// str = str.replace(/\s/g, '');
		str = T.str_nospace(str);
		symb = [];
		oper = [];
		for (var i = 0; i < str.length; i++) {
			var c = str.charAt(i);
			i%2 == 0 ? symb.push(c) : oper.push(c);
		  }		  
		// console.log("Sym " + symb.toString());
		// console.log("Ope " + oper.toString());
	}
	
	function countParenth()
	{
		var n = symb.length;
	    var mF = T.getMatrix(n,n);
	    var mT = T.getMatrix(n,n);
	    //
	    for (var i = 0; i < n; i++)
	    {
	    	mF[i][i] = 0; mT[i][i] = 0;// == cause error, use .equals()
	    	if(symb[i] == "F") { mF[i][i] = 1;}//T[i][i] = symbol[i] == 'T' ? 1 : 0;
	    	if(symb[i] == "T") { mT[i][i] = 1;}//F[i][i] = symbol[i] == 'F' ? 1 : 0;
	    	//System.out.println(symb[i] + ": " + F[i][i]); 
	    }
	 
	    // Now fill T[i][i+1], T[i][i+2], T[i][i+3]... in order
	    // And F[i][i+1], F[i][i+2], F[i][i+3]... in order
	    for (var gap=1; gap<n; ++gap)
	    {
	        for (var i=0, j=gap; j<n; ++i, ++j)
	        {
	            mT[i][j] = mF[i][j] = 0;
	            for (var g=0; g<gap; g++)
	            {
	                // Find place of parenthesization using current value of gap
	                var k = i + g;
	                // Store Total[i][k] and Total[k+1][j]
	                var tik = mT[i][k] + mF[i][k];
	                var tkj = mT[k+1][j] + mF[k+1][j];
	                // Follow the recursive formulas according to the current operator
	                if (oper[k] == "&")
	                {
	                    mT[i][j] += mT[i][k]*mT[k+1][j];
	                    mF[i][j] += (tik*tkj - mT[i][k]*mT[k+1][j]);
	                }
	                if (oper[k] == "|")
	                {
	                    mF[i][j] += mF[i][k]*mF[k+1][j];
	                    mT[i][j] += (tik*tkj - mF[i][k]*mF[k+1][j]);
	                }
	                if (oper[k] == "^")
	                {
	                    mT[i][j] += mF[i][k]*mT[k+1][j] + mT[i][k]*mF[k+1][j];
	                    mF[i][j] += mT[i][k]*mT[k+1][j] + mF[i][k]*mF[k+1][j];
	                }
	            }
	        }
	    }
	    return mT[0][n-1];
	}

	function BuildResult() {
		var txt = txt_time;
		txt += "\nNumber of ways to parenthesize the expression: " + txt_result;
		partResultChange(
			Template.simple01("key1", "Result", txt, 22, 22)
			// Template.simple01x2( "set1", "Result", txt, 22, "Frequencies", txt_result, 20 )
		);
	}

	return (
		<GUIset_nButton
			title={"Boolean Parenthesization"}
			desc={
				"Count the number of ways we can parenthesize the expression so that the value of expression evaluates to TRUE."
			}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Input"}
			// buttonList={["Random Input","Calculate"]}
			buttonList={buttonList}
		/>
	);
};

export default BooleanParenthesization;
